export default function Loader() {
  return (
    <div className="lds-ripple"><div></div><div></div></div>
  );
}